export default [
    // *===============================================---*
    // *--------- USER ---- ---------------------------------------*
    // *===============================================---*
    {
        path: '/admin',
        name: 'admin-dashboard',
        component: () => import('@/views/pages/admin/Dashboard.vue'),
        meta: {
            resource: 'Admin',
            action: 'manage',
        },
    },
]